import { SubCategory } from './sub-category';

interface CategoryAttributes {
	readonly id: string;
	readonly name: string;
	readonly description: string;
	readonly sub_categories: SubCategory[];
}

export class Category {
	public readonly id: string;
	public readonly name: string;
	public readonly description: string;
	public readonly sub_categories: SubCategory[];

	constructor({ id, name, description, sub_categories }: CategoryAttributes) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.sub_categories = sub_categories;
	}
}
